export default {
    data () {
        return {
            tickets: [],
            loading: false,
            search: "",
        };
    },
    methods: {
        searchTickets (query, url = "/tickets/search") {
            // If query is empty Element passes an "element" instance, convert to string
            if (!_.isString(query)) {
                query = "";
            }

            this.search = query;
            this.loading = true;
            axios.get(url, {params: {filter_text: query, sort: {id: 'desc'}}})
            .then(response => {
                this.tickets = response.data;
                this.loading = false;
            });
        }
    }
};
